import { SalesChannelType } from '@fd/customHooks/useQueryRMSSalesChannels';

export const getIsFlipdishChannel = (channel: SalesChannelType) =>
  [
    SalesChannelType.FLIPDISH_KIOSK,
    SalesChannelType.FLIPDISH_MOBILE_APP,
    SalesChannelType.FLIPDISH_WEB_APP,
    SalesChannelType.FLIPDISH_PHONE_AGENT,
  ].includes(channel || '');

export const getIsMarketplaceChannel = (channel: SalesChannelType) =>
  [SalesChannelType.JUST_EATS, SalesChannelType.UBER_EATS, SalesChannelType.DELIVEROO].includes(
    channel || ''
  );

export type SalesChannelsGrouped = typeof salesChannelsGrouped;
export const salesChannelsGrouped = {
  pos: [{ value: SalesChannelType.POS, label: 'POS' }],
  kiosk: [{ value: SalesChannelType.FLIPDISH_KIOSK, label: 'Flipdish Kiosk' }],
  'mobile-apps': [
    {
      value: SalesChannelType.FLIPDISH_MOBILE_APP,
      label: 'Flipdish Mobile App',
    },
  ],
  website: [
    {
      value: SalesChannelType.FLIPDISH_WEB_APP,
      label: 'Flipdish Web App',
    },
  ],
  'phone-agent': [
    {
      value: SalesChannelType.FLIPDISH_PHONE_AGENT,
      label: 'Flipdish Phone Agent',
    },
  ],
  marketplaces: [
    { value: SalesChannelType.JUST_EATS, label: 'Just Eat' },
    { value: SalesChannelType.UBER_EATS, label: 'Uber Eats' },
    { value: SalesChannelType.DELIVEROO, label: 'Deliveroo' },
  ],
};

export const getSalesChannelGroupByLabel = (label?: string) => {
  if (label) {
    for (const group of Object.values(salesChannelsGrouped)) {
      if (group.some((option) => option.value === label)) {
        return group;
      }
    }
  }
  return undefined;
};

export const getBackToSalesChannelListUrl = ({ appId, pathname, propertyId = '' }) => {
  switch (true) {
    case pathname.includes('website'):
      return `/${appId}/sales-channels/website?tab=sales-channels`;
    case pathname.includes('kiosk'):
      return `/${appId}/sales-channels/kiosk?tab=sales-channels`;
    case pathname.includes('properties'):
      return `/${appId}/properties/${propertyId}?tab=sales-channels`;
    case pathname.includes('marketplaces'):
      return `/${appId}/sales-channels/marketplaces?tab=sales-channels`;
    case pathname.includes('mobile-apps'):
      return `/${appId}/sales-channels/mobile-apps?tab=sales-channels`;
    case pathname.includes('phone-agent'):
      return `/${appId}/sales-channels/phone-agent?tab=sales-channels`;
    default:
      return `/${appId}/sales-channels/point-of-sale?tab=sales-channels`;
  }
};

export const getSalesChannelTypeFromUrl = (pathname: string) => {
  if (pathname.includes('website')) return SalesChannelType.FLIPDISH_WEB_APP;
  if (pathname.includes('kiosk')) return SalesChannelType.FLIPDISH_KIOSK;
  if (pathname.includes('mobile-apps')) return SalesChannelType.FLIPDISH_MOBILE_APP;
  if (pathname.includes('phone-agent')) return SalesChannelType.FLIPDISH_PHONE_AGENT;
  return SalesChannelType.POS;
};

export const getSalesChannelSettingBaseUrl = ({
  appId,
  propertyId,
  channelId,
  channelType,
}: {
  appId: string;
  propertyId: string;
  channelId: string;
  channelType: SalesChannelType;
}) => {
  const basePath = `/${appId}/sales-channels`;

  switch (true) {
    case channelType === SalesChannelType.FLIPDISH_WEB_APP:
      return `${basePath}/website/property/${propertyId}/sales-channel/${channelId}`;
    case channelType === SalesChannelType.FLIPDISH_KIOSK:
      return `${basePath}/kiosk/property/${propertyId}/sales-channel/${channelId}`;
    case channelType === SalesChannelType.DELIVEROO:
    case channelType === SalesChannelType.UBER_EATS:
    case channelType === SalesChannelType.JUST_EATS:
      return `${basePath}/marketplaces/property/${propertyId}/sales-channel/${channelId}`;
    case channelType === SalesChannelType.FLIPDISH_MOBILE_APP:
      return `${basePath}/mobile-apps/property/${propertyId}/sales-channel/${channelId}`;
    case channelType === SalesChannelType.FLIPDISH_PHONE_AGENT:
      return `${basePath}/phone-agent/property/${propertyId}/sales-channel/${channelId}`;
    default:
      return `${basePath}/point-of-sale/property/${propertyId}/sales-channel/${channelId}`;
  }
};
